'use client';

import React, { useEffect, useState, useRef } from 'react';
import styles from './scss/segmentation.module.scss';
import { getLycaSegementationTargetExperience } from '../../apiservice/aiLycaPilot';

// Typing effect component
const TypingText = ({
  text,
  onDone,
  speed = 50,
}: {
  text: string | number;
  onDone?: () => void;
  speed?: number;
}) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    let i = 0;
    const safeText = String(text); // ✅ ensure it's always a string
    setDisplayedText('');
    const interval = setInterval(() => {
      setDisplayedText(safeText.slice(0, i + 1));
      i++;
      if (i === safeText.length) {
        clearInterval(interval);
        if (onDone) onDone();
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, onDone]);

  return <>{displayedText}</>;
};

// ✅ Main Component
const SegMent1 = ({ onComplete }: { onComplete?: () => void }) => {
  const [data, setData] = useState<any[]>([]);
  const [visibleSection, setVisibleSection] = useState(0);
  const [phase, setPhase] = useState<'title' | 'desc' | 'chart' | 'done'>('title');
  const chartRefs = useRef<(HTMLDivElement | null)[]>([]);
console.log('data--',data[0])
  // Fetch API Data
  const getLycaSegementationTargetData = async (body: any) => {
    try {
      const res = await getLycaSegementationTargetExperience(body);
      if (res?.data?.statusCode === 200) {
        const responseData = res.data.response;
        setData(responseData);
      }
    } catch (error) {
      console.error('Error fetching segmentation target data:', error);
    }
  };

  useEffect(() => {
    const body = { fromYear: '2024', toYear: '2025', domainId: ' ' };
    getLycaSegementationTargetData(body);
  }, []);

  // Example static sections (later you can map from `data`)
  const sections = [
    {
      title: data[0]?.Customers ?? 0,
      desc: 'Active Customers',
      chart: 'Active customers interacting across multiple touchpoints.',
      color: 'linear-gradient(180deg, #FFF 50%, #F5FFFC 100%)',
    },
    {
      title: data[0]?.Segment ?? 0,
      desc: 'Segments',
      chart: 'Customer groups based on shared traits, behavior, or value.',
      color: 'linear-gradient(180deg, #FFF 50%, #F5F5FF 100%)',
    },
    {
      title: data[0]?.inactiveCustomers ?? 0,
      desc: 'Inactive Customers',
      chart: 'Previously active customers who’ve stopped interacting or transacting recently.',
      color: 'linear-gradient(180deg, #FFF 50%, #FFFFF5 100%)',
    },
    {
      title: data[0]?.Complaints ?? 0,
      desc: 'Complaints',
      chart: 'Reported customer issues that may impact satisfaction and retention.',
      color: 'linear-gradient(180deg, #FFF 50%, #FFFFF5 100%)',
    },
  ];

  // Auto scroll when section changes
  useEffect(() => {
    chartRefs.current[visibleSection]?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, [visibleSection]);

  // Reset phase on new section
  useEffect(() => {
    setPhase('title');
  }, [visibleSection]);

  // Typing flow control
  const onTypingDone = () => {
    if (phase === 'title') {
      setPhase('desc');
    } else if (phase === 'desc') {
      setPhase('chart');
    } else if (phase === 'chart') {
      setPhase('done');
      setTimeout(() => {
        if (visibleSection < sections.length - 1) {
          setVisibleSection((prev) => prev + 1);
        } else {
          onComplete?.(); // ✅ Trigger after last section
        }
      }, 300);
    }
  };

  return (
    <div className={styles.allotmentsecsegt}>
      {sections.map((section, i) => {
        if (i > visibleSection) return null;

        const isCurrent = i === visibleSection;

        return (
          <div
            key={i}
            className={styles.altblocksegt}
            style={{ background: section.color }}
            ref={(el) => (chartRefs.current[i] = el)}
          >
            <p className={styles.altcount}>
              {isCurrent ? (
                phase === 'title' ? (
                  <TypingText text={section.title} onDone={onTypingDone} />
                ) : (
                  section.title
                )
              ) : (
                section.title
              )}
            </p>

            <div className={styles.altinfos}>
              <h4>
                {isCurrent ? (
                  phase === 'desc' ? (
                    <TypingText text={section.desc} onDone={onTypingDone} />
                  ) : phase === 'title' ? (
                    ''
                  ) : (
                    section.desc
                  )
                ) : (
                  section.desc
                )}
              </h4>
              <p>
                {isCurrent ? (
                  phase === 'chart' ? (
                    <TypingText text={section.chart} onDone={onTypingDone} />
                  ) : phase === 'done' ? (
                    section.chart
                  ) : (
                    ''
                  )
                ) : (
                  section.chart
                )}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SegMent1;
